import {useStyles} from '../../../hooks/styles';
import {hexToRgbA} from '../../../pipes';
import {DeviceSize} from '../../../theme/helpers';

export function useMapDetailsStyles() {
  return useStyles(({addShadow, theme, mediaOnly}) => ({
    info: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,

      backgroundColor: theme.color.backgroundMenuColor,

      zIndex: 2,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          paddingTop: 80,
          paddingBottom: 120,
          paddingHorizontal: 26,
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
          width: '40%',
          ...addShadow({
            opacity: 0.1,
            width: 0,
            height: 2,
            radius: 18,
          }),
        },
        {
          paddingTop: 20,
          paddingHorizontal: 16,
        },
      ),
      ...mediaOnly(DeviceSize.tablet, {width: '60%'}),
      ...mediaOnly(DeviceSize.mobile, {width: '80%'}),
    },
    infoBlock: {
      marginBottom: 5,
    },
    infoRow: {
      marginBottom: 18,
    },
    title: {
      marginBottom: 12,
      color: theme.color.textColor,

      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5,
        },
        {
          ...theme.fonts.body,
        },
      ),
    },
    rowWithIcon: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    icon: {
      marginRight: 12,
      color: theme.color.primaryColor,
      justifyContent: 'center',
      width: 24,
      height: 24,
    },
    groupItem: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    text: {
      lineHeight: 24,

      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5Light,
        },
        {
          ...theme.fonts.bodySmallLight,
        },
      ),
    },
    closeButton: {
      position: 'absolute',
      zIndex: 2,
      alignItems: 'center',
      justifyContent: 'center',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          width: 44,
          height: 44,
          right: 15,
          top: 15,
          color: theme.color.textColor,
        },
        {
          width: 24,
          height: 24,
          right: 12,
          top: 12,
          color: theme.color.textColor,
        },
      ),
    },
    closeButonIcon: mediaOnly(
      DeviceSize.desktop,
      {
        width: 36,
        height: 36,
        color: theme.color.textColor,
      },
      {
        width: 24,
        height: 24,
        color: theme.color.textColor,
      },
    ),
    bgImage: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
    },
    backdrop: {
      display: 'none',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: hexToRgbA('#000', 0.2),
      zIndex: 1,
    },
    backdropVisible: {
      display: 'flex',
    },
    backdropTouchable: {
      width: '100%',
      flex: 1,
    },
  }));
}
